import './style.css';
import React from 'react';
import Icons from './icons';

const Icon = ({ icon, alt, ...otherProps }) => (
  <span className="icon" alt={alt} {...otherProps}>
    {Icons[icon]}
  </span>
);

export default Icon;
